import { render, staticRenderFns } from "./medical-documents-actions-cell.vue?vue&type=template&id=36c294b2&scoped=true&"
import script from "./medical-documents-actions-cell.vue?vue&type=script&lang=js&"
export * from "./medical-documents-actions-cell.vue?vue&type=script&lang=js&"
import style0 from "./medical-documents-actions-cell.vue?vue&type=style&index=0&id=36c294b2&lang=css&"
import style1 from "./medical-documents-actions-cell.vue?vue&type=style&index=1&id=36c294b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c294b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c294b2')) {
      api.createRecord('36c294b2', component.options)
    } else {
      api.reload('36c294b2', component.options)
    }
    module.hot.accept("./medical-documents-actions-cell.vue?vue&type=template&id=36c294b2&scoped=true&", function () {
      api.rerender('36c294b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/data-table/medical-documents-actions-cell.vue"
export default component.exports